import script from "./AgentReplyDraft.vue?vue&type=script&setup=true&lang=ts"
export * from "./AgentReplyDraft.vue?vue&type=script&setup=true&lang=ts"

import "./AgentReplyDraft.vue?vue&type=style&index=0&id=0f6a6d22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f6a6d22"]])

export default __exports__